<template>
    <v-container v-resize="onResize" fluid pa-0 v-if="active">
      <v-flex xs12>
        <div class="imageEditorApp flex xs12">
        <tui-image-editor ref="tuiImageEditor"
                          :include-ui="useDefaultUI"
                          :options="options"
                          >
        </tui-image-editor>
    </div>
      </v-flex>
    </v-container>
</template>

<script>
/* global session store config */
import { ImageEditor } from '@toast-ui/vue-image-editor';
import 'tui-image-editor/dist/tui-image-editor.css';
import 'tui-color-picker/dist/tui-color-picker.css';
import { upload } from '../helpers/aws';
import $ from 'jquery';
import { mapGetters } from 'vuex';
import is from 'is_js';

export default {
  name: 'image-editor',
  components: {
    'tui-image-editor': ImageEditor
  },
  props: {
    photo: {
      type: Object,
      default: {}
    },
    active: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'album'
    }
  },
  data: () => ({
    useDefaultUI: true,
    config: config,
    options: {
      includeUI: {
        loadImage: {
          path: '',
          name: 'SampleImage'
        },
        uiSize: {
          width: `${window.innerWidth}`,
          height: `${window.innerHeight}`
        },
        menuBarPosition: 'top',
        menu: ['crop', 'flip', 'rotate', 'draw', 'shape', 'text', 'filter']
      },
      cssMaxWidth: window.innerWidth - 20,
      cssMaxHeight: window.outerHeight - 450,
    },
  }),
  computed: {
    ...mapGetters(['Album', 'AlbumPhoto'])
  },
  watch: {
    photo: {
      handler: function (after, before) {
        let isSSL = window.location.protocol.indexOf('https') > -1 && !is.chrome() && !is.safari();
        this.options.includeUI.loadImage.path = isSSL && this.photo.original_url ? this.photo.original_url : this.photo.original_url ? this.photo.original_url.replace('https', 'http') + '?' + Math.random() : '';
        if (after.original_url) {
          this.changeButtons();
        }
      },
      deep: true
    }
  },
  methods: {
    onResize () {
      this.options.includeUI.uiSize.width = `${window.innerWidth}`;
      this.options.includeUI.uiSize.height = `${window.innerHeight}`;
      this.options.cssMaxWidth = Number(window.innerWidth) - 50;
    },
    changeButtons () {
      if (this.type !== 'album') {
        this.options.includeUI.menu = ['flip', 'rotate', 'draw', 'shape', 'text', 'filter'];
      } else {
        this.options.includeUI.menu = ['crop', 'flip', 'rotate', 'draw', 'shape', 'text', 'filter'];
      }
      this.$nextTick(function () {
        $('.tui-image-editor-controls-buttons').remove();
        $('.tui-image-editor-controls-logo').remove();
        $('.tui-image-editor-controls').prepend('<ul class="tui-image-editor-menu mt-2"></ul>');
        $('.tui-image-editor-menu:first').append('<button id="editorSave" class="pf-btn pf-btn-save v-btn text-uppercase mr-2">Save</button>');
        $('.tui-image-editor-menu:first').append('<button id="editorCancel" class="pf-btn pf-btn-cancel v-btn text-uppercase">Cancel</button>');
        $('#editorSave').click(this.editorSave);
        $('#editorCancel').click(this.editorClose);
        $('li[class="tui-image-editor-item"]').remove();
        $('html, body').animate({ scrollTop: '0' }, 1000);
      });
    },
    editorClose () {
      window.getApp.$emit('photoEdit', false, {});
    },
    async editorSave (e) {
      e.preventDefault();
      window.getApp.$emit('saveProgress', true);
      let photoId = this.photo.id;
      let canvas = document.getElementsByClassName('lower-canvas')[0];
      let key_arr = this.photo.original_url.split(`${this.config.s3Bucket}.s3.amazonaws.com/`);
      let image = canvas.toDataURL('image/jpeg');
      let photoKey = '';
      if (key_arr[1]) {
        photoKey = key_arr[1];
      }
      let buf = Buffer.from(image.replace(/^data:image\/\w+;base64,/, ''), 'base64');
      let { uploadError: uploadErrorThumb, response: uploadResponse } = await upload({
        Bucket: this.config.s3Bucket,
        Key: photoKey,
        Body: buf,
        ContentEncoding: 'base64', // required
        ContentType: `image/jpeg` // required. Notice the back ticks
      });

      if (uploadErrorThumb) {
        console.log(`Unable to upload thumb`, uploadErrorThumb);
      }
      else {
        let photoDetails = this.photo;
        let r = Math.random().toString(36).substring(7);
        let albumPhotoThumb = this.photo.original_url.replace('/original/', '/thumb/') + '?' + r;
        let albumPhotoWebview = this.photo.original_url.replace('/original/', '/webview/') + '?' + r;
        if (this.type === 'avatar') {
          $('.avatar').css('background', 'url(/static/loading_temp.gif) 50% 50% / cover no-repeat');
          let avatar = albumPhotoThumb;
          setTimeout(function () { 
            $('.avatar').css('background', 'url(' + avatar + ') 50% 50% / cover no-repeat');
          }, 10000);
        } else if (this.type === 'banner') {
          let banner = this.photo.original_url + '?' + r;
          $('.v-parallax__image').attr('src', banner);
        } else {
          $('#photo-' + photoId).css('background-image', 'url(/static/loading_temp.gif');
          let storeAlbumPhoto = this.AlbumPhoto[photoDetails.album].find(item => item.id === photoDetails.id);
          const albumIndex = this.Album.findIndex(item => item.id === photoDetails.album);
          let album = this.Album;
          let currentDefaultPhoto = false;
          if (album[albumIndex] && album[albumIndex].default_photo && album[albumIndex].default_photo.id === photoDetails.id) {
            currentDefaultPhoto = true;
          }
          setTimeout(function () { 
            $('#photo-' + photoId).css('background', 'url(' + albumPhotoThumb + ') 50% 50% / cover no-repeat');
            photoDetails.thumb_url = albumPhotoThumb;
            photoDetails.webview_url = albumPhotoWebview;
            storeAlbumPhoto = photoDetails;
            if (currentDefaultPhoto) {
              album[albumIndex].default_photo = photoDetails;
            }
          }, 15000);
        }
        console.log('Upload Successful');
        window.getApp.$emit('photoEdit', false, {});
      }
      window.getApp.$emit('saveProgress', false);
    }
  },
};
</script>
<style scoped>
.imageEditorApp >>> .pf-btn {
  border-radius: 20px;
  outline: none;
}
.imageEditorApp {
    height: 680px;
}
.imageEditorApp >>> .tui-image-editor-controls {
  display: grid;
  height: auto;
}
.imageEditorApp >>> .tie-btn-delete.tui-image-editor-item, .imageEditorApp >>> .tie-btn-deleteAll.tui-image-editor-item {
  display: none !important;
}

@media only screen and (max-width: 540px) {
  .imageEditorApp >>> .tui-image-editor-container .tui-image-editor-menu > .tui-image-editor-item {
    padding: 0px;
    padding-top: 8px;
  }
  .imageEditorApp >>> .pf-btn {
    min-width: 80px;
  }
}
.imageEditorApp >>> .tui-image-editor-container .tui-image-editor-main {
    top: 110px;
}
.imageEditorApp >>> .tui-image-editor-icpartition {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ImageEditor.vue